import { buildArticle } from "./_articleBuilder";

export default buildArticle({
  slug: "what-is-personalized-tms-targeting",
  title: "What Is Personalized TMS Targeting?",
  description:
    "Personalized TMS targeting uses fMRI to map the treatment target specific to your brain. Learn how SAINT® uses fMRI-guided targeting.",
  keywords:
    "personalized TMS targeting, fMRI TMS, SAINT targeting, individualized TMS, brain mapping TMS",
  badge: "Educational Article",
  heroTitle: "What Is Personalized TMS Targeting?",
  heroSubtitle:
    "Traditional TMS uses a standard measurement to find the treatment target. Personalized targeting uses your brain's own connectivity map to identify the target specific to you.",
  sections: [
    {
      heading: "How Traditional TMS Finds Its Target",
      body: "Standard TMS aims at a region of the brain called the left dorsolateral prefrontal cortex. A technician typically finds your motor threshold and measures forward along the scalp to land on the target. This works, but it's based on population averages.",
    },
    {
      heading: "What Personalized Targeting Does Differently",
      body: "SAINT® uses an fMRI scan to capture how regions of your brain are connected at rest. A proprietary algorithm then identifies the specific subregion most connected to a deeper area involved in mood regulation. That coordinate is yours — it doesn't come from an average.",
    },
    {
      heading: "What the Scan Is and Isn't",
      body: "The scan is a targeting input, not a diagnostic tool. No fMRI diagnoses depression. The scan guides where to aim; it doesn't confirm you have the condition or predict whether you'll respond.",
      callout: true,
    },
    {
      heading: "Why It Matters",
      body: "Individual brains vary in where functional regions sit relative to skull landmarks. Personalized targeting accounts for that variation, aiming at a location specific to your brain rather than a population average.",
    },
  ],
  faq: [
    {
      question: "Does the fMRI scan diagnose depression?",
      answer:
        "No. The fMRI is used to guide treatment targeting, not to diagnose depression. No fMRI diagnoses depression.",
    },
    {
      question: "Can I get personalized targeting with any TMS?",
      answer:
        "Personalized fMRI-guided targeting is a feature of the SAINT® protocol specifically. Not all TMS uses this approach. Traditional TMS relies on standard scalp-based measurement.",
    },
  ],
  related: [
    {
      title: "SAINT® vs. Traditional TMS",
      href: "/learn/saint-vs-traditional-tms",
    },
    { title: "What Is Accelerated TMS?", href: "/what-is-accelerated-tms" },
    { title: "SAINT® Overview", href: "/saint" },
  ],
  finalCtaText:
    "Questions about how targeting works are welcome. Speak with our team to learn more.",
});
